import { homeTabs } from '@shared/lib/gtm/redesign'

const navbarTabByLabel = {
  Главная: homeTabs.glavnaya,
  Steam: homeTabs.steam,
  Донаты: homeTabs.igry,
  Сервисы: homeTabs.servisy,
  Ещё: homeTabs.esche,
} as const

export const getNavbarTabEventLabel = (label: string) => navbarTabByLabel[label as keyof typeof navbarTabByLabel]
